import { DsInput } from '@demvsystems/design-components';

import AsyncSelect from '@/components/form-elements/AsyncSelect/AsyncSelect.vue';
import { birthdayConfig } from '@/components/form-elements/Datepicker/configs';
import Datepicker from '@/components/form-elements/Datepicker/Datepicker.vue';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import type { FormConfig } from '@/utils/form/types';

export const mitversicherterPartnerInformationFormConfig: FormConfig = {
  formName: 'ContractMvp',
  fieldConfigs: [
    {
      component: AsyncSelect,
      path: 'anredeId',
      label: 'Anrede',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.SALUTATION,
      },
      clientField: true,
      isRequired: true,
      skipLiveValidationWhenEqual: ['4'],
    },
    {
      component: DsInput,
      path: 'vorname',
      label: 'Vorname',
      inputAttrs: {
        immediate: true,
      },
      isRequired: true,
      clientField: true,
    },
    {
      component: DsInput,
      path: 'nachname',
      label: 'Nachname',
      inputAttrs: {
        immediate: true,
      },
      isRequired: true,
      clientField: true,
    },
    {
      component: Datepicker,
      path: 'geburtsdatum',
      label: 'Geburtsdatum',
      inputAttrs: {
        datepickerConfig: birthdayConfig,
      },
      isRequired: true,
      clientField: true,
    },
    {
      component: AsyncSelect,
      path: 'berufsgruppe',
      label: 'Berufsgruppe',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.PROFESSION,
      },
      isRequired: true,
      clientField: true,
    },
    {
      component: DsInput,
      path: 'beruf',
      label: 'Beruf',
      isRequired: true,
      clientField: true,
    },
  ],
};
